module.exports = __webpack_public_path__ + "media/images/logos/logo-edone-white-b66428f79f5b03f174b87fefd459cbd0.svg";